import cs from 'classnames'
import React, { FC, ReactNode } from 'react'

import s from './WixMobileHeading.scss'

interface WixMobileHeadingProps {
  dataHook?: string
  textAlign?: 'left' | 'center' | 'right'
  skin?: 'default' | 'harmony' | 'harmony-v3'
  children?: ReactNode
}

export const WixMobileHeading: FC<WixMobileHeadingProps> = ({ children, dataHook, textAlign, skin = 'default' }) => (
  <h1
    className={cs(s.heading, {
      [s.left]: textAlign === 'left',
      [s.right]: textAlign === 'right',
      [s.harmony]: skin === 'harmony' || skin === 'harmony-v3',
      [s.harmonyV3]: skin === 'harmony-v3',
    })}
    data-hook={dataHook}
  >
    {children}
  </h1>
)
